import EmployeeMappingActionTypes from "../constants/employeeMapping-actionTypes";

export const getEmployeeMappingData = (email) => ({
    type: EmployeeMappingActionTypes.GET_EMPLOYEEMAPPING_DATA,
    email: email
});

export const getEmployeeMappingRolesData = () => ({
    type: EmployeeMappingActionTypes.GET_EMPLOYEEMAPPING_ROLES
});

export const getEmployeeMappingAccountsData = () => ({
    type: EmployeeMappingActionTypes.GET_EMPLOYEEMAPPING_ACCOUNTS
});

export const getEmployeeMappingSitesData = () => ({
    type: EmployeeMappingActionTypes.GET_EMPLOYEEMAPPING_SITES
});

export const  updateUsermembershipDataStart= (data) => (
      {
        type: EmployeeMappingActionTypes.UPDATE_USERMEMBERSHIP_DATA_START,
        payload: data,
      }
    )
    
    export const updateUsermembershipDataSuccess = () => (
      {
        type: EmployeeMappingActionTypes.UPDATE_USERMEMBERSHIP_DATA_SUCCESS,
      }
    )

export const  updateUsermembershipDeleteStart= (data,callback) => (
      {
        type: EmployeeMappingActionTypes.UPDATE_USERMEMBERSHIP_DELETE_START,
        payload: data,
        callback
      }
    )
    
    export const updateUsermembershipDeleteSuccess = () => (
      {
        type: EmployeeMappingActionTypes.UPDATE_USERMEMBERSHIP_DELETE_SUCCESS,
      }
    )

